import React from "react";
import Portal from "@reach/portal";
import styles from "./Loader.module.css";
import { ReactComponent as Logo } from "../../../assets/loadericon.svg";
import { ReactComponent as SmallLogo } from "../../../assets/logo-pink-sm.svg";

export const ProcessingLoader = () => {
  return (
    <div className={styles.processing_container}>
      <div className={styles.spin}>
        <div className={styles.spinner_logo}>
          <SmallLogo />
        </div>
        <div className={styles.spinner}> </div>
      </div>
    </div>
  );
};

export const ButtonLoader = () => {
  return (
    <div className={styles.button_loader_container}>
      <div className={styles.spin}>
        <div className={styles.spinner_logo}>
          <SmallLogo className={styles.spinner_white} />
        </div>
        <div className={styles.white_spinner}> </div>
      </div>
    </div>
  );
};

const Loader = ({ isLoading = false }) => {
  if (!isLoading) {
    return null;
  }
  return (
    <Portal>
      <div className={styles.container}>
        <div className={styles.spin}>
          <div className={styles.spinner_logo}>
            <Logo />
          </div>
          <div className={styles.spinner}> </div>
        </div>
      </div>
    </Portal>
  );
};

export default Loader;
